import { DATASET_TANKERS } from '_legacy/models/Datasets';

const toComparableId = (value) => {
    if (value === null || value === undefined) {
        return null;
    }

    return `${value}`;
};

const resolveTankersGroupFilterValues = (
    groupId,
    specialTankersReportGroupIds = []
) => {
    const currentGroupId = toComparableId(groupId);

    if (!currentGroupId) {
        return [];
    }

    const specialGroupCollection = specialTankersReportGroupIds.find(
        (groupCollection) =>
            Array.isArray(groupCollection) &&
            groupCollection.some(
                (specialGroupId) =>
                    toComparableId(specialGroupId) === currentGroupId
            )
    );

    if (specialGroupCollection) {
        return specialGroupCollection.map((group) => toComparableId(group));
    }

    return [currentGroupId];
};

export const getPowerBiReportFilters = ({
    datasetId,
    groupId,
    enableSpecialTankersReports,
    specialTankersReportGroupIds,
    datasetFilterTarget,
    pbi,
}) => {
    if (datasetId === DATASET_TANKERS && enableSpecialTankersReports) {
        const groupFilterValues = resolveTankersGroupFilterValues(
            groupId,
            specialTankersReportGroupIds
        );

        if (!groupFilterValues.length) {
            return [];
        }

        return [
            {
                $schema: 'http://powerbi.com/product/schema#basic',
                target: {
                    table: 'Group',
                    column: 'GroupId',
                },
                operator: 'In',
                values: groupFilterValues,
                filterType: pbi.models.FilterType.BasicFilter,
            },
        ];
    }

    return [
        {
            $schema: 'http://powerbi.com/product/schema#basic',
            target: datasetFilterTarget,
            operator: 'In',
            values: [datasetId],
            filterType: pbi.models.FilterType.BasicFilter,
        },
    ];
};
